import {
  Paper,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import EmptyPage from '../utility_objects/EmptyPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons';

function BrowserNotCompatible() {
  return (
    <EmptyPage>
      <Paper sx={{ zIndex: 1000, padding: '20px' }}>
        <Stack flexDirection="column" spacing={3}>
          <Stack flexDirection="column" alignItems="center" spacing={2}>
            <FontAwesomeIcon
              style={{ fontSize: '68px', color: 'var(--alert-color)' }}
              icon={faTriangleExclamation}
            />
            <Typography variant="h4" gutterBottom>
              Attenzione
            </Typography>
          </Stack>
          <Typography variant="body1" gutterBottom>
            La versione del browser che stai utilizzando non è compatibile con
            questa applicazione.
            <br />
            <br />
            Ti consigliamo di aggiornare il browser alle seguenti versioni o
            superiori:
          </Typography>

          <TableContainer>
            <Table size="small" aria-label="browser compatibili">
              <TableHead>
                <TableRow>
                  <TableCell>Browser</TableCell>
                  <TableCell>Versione minima supportata</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Microsoft Edge</TableCell>
                  <TableCell>121 +</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Google Chrome</TableCell>
                  <TableCell>109 +</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Mozilla Firefox</TableCell>
                  <TableCell>115 +</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Apple Safari</TableCell>
                  <TableCell>15.4 +</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Altri</TableCell>
                  <TableCell>Non supportati</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Paper>
    </EmptyPage>
  );
}

export default BrowserNotCompatible;
